<template>
  <div class="sidebar">
    <div class="sidebar-widget search-box">
      <div class="form-group">
        <input type="search" placeholder="Search" />
        <button type="submit">
          <i class="flaticon-search"></i>
        </button>
      </div>
    </div>

    <div class="sidebar-widget gallery-info-widget">
      <div class="gallery-info-item-wrap">
        <div class="gallery-info-item">
          <p><i class="ri-calendar-line"></i>Date:</p>
          <span>22 Mar, 2022</span>
        </div>
        <div class="gallery-info-item">
          <p><i class="ri-user-unfollow-line"></i>Client:</p>
          <span>Will Smith</span>
        </div>
        <div class="gallery-info-item">
          <p><i class="ri-map-pin-line"></i>Client Location:</p>
          <span>Florida, USA</span>
        </div>
        <div class="gallery-info-item">
          <p><i class="ri-bookmark-line"></i>Category:</p>
          <span>Clinical Surgery</span>
        </div>
        <div class="gallery-info-item">
          <p><i class="ri-hospital-line"></i>Skills:</p>
          <span>Surgery</span>
        </div>
      </div>
    </div>

    <div class="sidebar-widget contact-widget bg-f hero-bg-12">
      <div class="overlay bg-prussian op-9"></div>
      <h3>Need Health Checkup?</h3>
      <a href="tel:13454567877">+1-3454-5678-77</a>
      <a href="mailto:hello@duch.com">hello@duch.com</a>
      <router-link to="/" class="btn style2">Contact Us</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideBar",
};
</script>